// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"use-labels-editor-module__SanitizedHtml__G_WQ29D","Box":"use-labels-editor-module__Box__AncMZnT"};